// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"b84e08ea","94":"b2312ec4","223":"12910b8c","246":"a45be571","366":"a84e2d96","407":"20425e53","480":"b31379b8","610":"6b867f17","659":"90a1a39a","842":"b56727ef","970":"47e01b6c"}[chunkId] + ".chunk.js";
};